// A full page load to another address (the identity provider's sign-out, the hosted sign-in):
// one place, so tests can see where the console sent the browser.
export function leave(url: string): void {
  window.location.assign(url)
}
